<template>
  <div class="ChildAct">
    <SearchForm :fields="searchFields" @submit="handleSubmit"></SearchForm>
    <content-title>
      <template>
        <a-button @click="() => $refs.edit.show()" type="primary" v-primission="'OPEN_API_SUBACCOUNT_ADD'">
            {{$t('childAct_新增子账号')}}
        </a-button>
        <a-button style="margin-left: 8px;" @click="toOperationLog">
            {{$t('common_btn_ulog')}}
        </a-button>
      </template>
      <template v-slot:other>
        <div style="display: flex;color: rgba(0, 0, 0, 0.45);top: 1px;">
          <div class="refresh"
            v-tooltip="{
              content: `<div>${$t('common_刷新')}</div>`,
              html: true,
              placement: 'bottom'
            }"
          >
            <a-icon type="reload" @click="fetch" style="font-size: 14px;" />
          </div>
        </div>
      </template>
    </content-title>
    <div v-primission="'OPEN_API_SUBACCOUNT_VIEW'">
      <smart-table
        ref="smartTable"
        :base-url="baseURL"
        :api-path="apiPath"
        :default-param="defaultParam"
        :param="param"
        :columns="columns"
        :bordered="false"
        :row-key="(record, index) => index"
        :scroll="{ y: 600 }"
      >
        <template slot="isEffective" slot-scope="text, record">
          <span v-if="record.isEffective === 1" style="display: flex;align-items: center;"><div class="green"></div>{{$t('childAct_正常')}}</span>
          <span v-if="record.isEffective === 0" style="display: flex;align-items: center;"><div class="grey"></div>{{$t('childAct_冻结')}}</span>
        </template>
        <template slot="operate" slot-scope="text, record">
          <div class="childact-do">
            <a v-if="record.isEffective === 1" v-primission="'OPEN_API_SUBACCOUNT_FREEZE'" @click="operate('冻结', record)">{{$t('childAct_冻结')}}</a>
            <a v-if="record.isEffective === 0" v-primission="'OPEN_API_SUBACCOUNT_FREEZE'" @click="operate('启用', record)">{{$t('childAct_启用')}}</a>
            <a @click="() => $refs.edit.show(record)" v-primission="'OPEN_API_SUBACCOUNT_EDIT'">{{$t('common_menu_edit')}}</a>
          </div>
        </template>
      </smart-table>
    </div>
    <edit ref="edit" @submit="fetch"/>
    <!-- 操作日志 -->
    <!-- 侧边栏 -->
    <a-drawer
      :title="$t('common_menu_ulog')"
      placement="right"
      :width="1260"
      :wrapStyle="{ zIndex: 2000 }"
      :closable="true"
      :visible="drawerVisible"
      :get-container="() => $el"
      @close="drawerClose"
    >
      <Log v-if="drawerVisible"></Log>
    </a-drawer>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { SsogetChilldList, SsoGetDeactivateStaff } from '@/api/login'
import api from '@/api/index'
import { openNotificationWithIcon } from '@/utils/util'
import Edit from './components/Edit'
import SmartTable from '@/components/SmartTable_next'
import SearchForm from '@/components/SearchForm'
import Log from './Log'
import { mapState } from 'vuex'
import ContentTitle from '@/components/ContentTitle.vue'

export default {
  name: 'Applied',
  data () {
    return {
      systemName: '',
      appName: '',
      num: 11,
      loading: false,
      current: 1,
      isTips: false,
      uesrName: '',
      pwd: '',
      morepwNum: '',
      emailNum: '',
      phoneNum: '',
      chilldArray: [],
      total: '',
      isType: '',
      expandedKeys: [],
      isUserId: '',
      isDisabled: false,
      apiPath: api.SsogetChilldList,
      baseURL: api.baseURL,
      columns: [
        { title: this.$t('authority_account_name'), key: 'userName', dataIndex: 'userName', align: 'left', width: 170 },
        { title: this.$t('authority_account_full'), key: 'realName', dataIndex: 'realName', scopedSlots: { customRender: 'realName' }, align: 'left', width: 170 },
        { title: this.$t('authority_account_phone'), key: 'phone', dataIndex: 'phone', scopedSlots: { customRender: 'phone' }, align: 'left', width: 200 },
        { title: this.$t('common_form_email'), key: 'email', dataIndex: 'email', scopedSlots: { customRender: 'email' }, align: 'left', width: 200 },
        { title: this.$t('authority_account_status'), key: 'isEffective', dataIndex: 'isEffective', scopedSlots: { customRender: 'isEffective' }, align: 'left', wdith: 200 },
        { title: this.$t('developer_operation'), key: 'operate', dataIndex: 'operate', scopedSlots: { customRender: 'operate' }, wdith: 130 }
      ],
      param: {},
      defaultParam: { systemCode: '' },
      drawerVisible: false
    }
  },
  components: {
    SmartTable,
    Edit,
    ContentTitle,
    Log,
    SearchForm
    // VDistpicker
  },
    computed: {
    ...mapState({
      currentLang: state => state.isLogin.lang,
      'meunList': state => state.isLogin.meunList,
      'subjectId': state => state.isLogin.subjectId
    }),
    searchFields () {
      return [
        {
          type: 'select',
          name: 'isStatus',
          placeholder: this.$t('authority_account_select_status'),
          options: [
            { label: this.$t('common_home_announcement_type0'), value: 2 },
            { label: this.$t('childAct_正常'), value: 1 },
            { label: this.$t('childAct_冻结'), value: 0 }
          ]
        },
        { type: 'text', name: 'appName', placeholder: this.$t('childAct_姓名查询') }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('_SsoGetUserInfo')
    this.$refs.smartTable.fetch()
  },
  methods: {
    fetch () {
      this.$refs.smartTable.fetch()
    },
    /**
     * 查看操作日志
     */
    toOperationLog () {
      this.drawerVisible = true
    },
    handleChange (value) {
      this.isStatus = value
      // console.log(`selected ${value}`)
    },
    // searchApi () {
    //   this.param = {
    //     isEffective: this.isStatus === 2 ? '' : this.isStatus,
    //     realName: this.appName
    //   }
    // },
    handleSubmit (val) {
      this.param = {
        isEffective: val.isStatus === 2 ? '' : val.isStatus,
        realName: val.appName,
        pageNum: 1
      }
    },
    chilldList (current) {
      let data = {
        subjectId: this.subjectId,
        pageNum: current,
        pageSize: 10,
        paging: true
      }
      SsogetChilldList(data).then((res) => {
        if (res.code === '200') {
          this.chilldArray = res.dataList
          this.total = res.total
        } else {
          openNotificationWithIcon(res.message)
        }
      })
    },
    onChange (current) {
      this.current = current
      this.chilldList(current)
    },
    onCheck (checkedKeys, info) {
      console.log('onCheck', checkedKeys, info)
    },
    drawerClose () {
      this.drawerVisible = false
    },
    // 单选框
    onChange1 (e) {
      console.log('radio2 checked', e.target.value)
    },
    // 应用类型选择
    applictionChange (value) {
      // console.log(`selected ${value}`)
      this.plainOptions = []
      this.apiDocDTOList = []
      this.checkAll = false
      if (value === 1) { // 我的应用
        // this._QueryAuthService()
        this._QueryOwnerAppAuthInterface()
      } else {
        this._QueryListForApp()
      }
    },
    operate (type, item) {
      let data = {
        subjectId: this.subjectId,
        userIds: [item.userId],
        type: 'deact',
        systemCode: 'OPEN_API_PORTAL'
      }
      if (type === '冻结') {
        data.deactivateType = 0
        this.$confirm({
          title: type === '冻结' ? this.$t('childAct_冻结') : this.$t('childAct_启用'),
          content: this.$t('childAct_是否确定冻结该账号？本次操作只冻结该账号在开放平台的使用，若需要冻结该账号在用户中心的使用，请到用户中心操作'),
          okText: this.$t('common_btn_confirm'),
          cancelText: this.$t('common_btn_cancel'),
          onOk: () => {
            SsoGetDeactivateStaff(data).then((res) => {
              if (res.code === '200') {
                this.$message.success(this.$t('authority_account_操作成功'))
                this.fetch()
              } else {
                openNotificationWithIcon(res.message)
              }
            })
          },
          onCancel () {
            console.log('Cancel')
          }
        })
      }
      if (type === '启用') {
        data.deactivateType = 1
        this.$confirm({
          title: type === '启用' ? this.$t('childAct_启用') : this.$t('childAct_冻结'),
          content: this.$t('applied_btn_是否', [type === '启用' ? this.$t('childAct_启用') : this.$t('childAct_冻结')]),
          okText: this.$t('common_btn_confirm'),
          cancelText: this.$t('common_btn_cancel'),
          onOk: () => {
            SsoGetDeactivateStaff(data).then((res) => {
              if (res.code === '200') {
                this.$message.success(this.$t('authority_account_操作成功'))
                this.fetch()
              } else {
                openNotificationWithIcon(res.message)
              }
            })
          },
          onCancel () {
            console.log('Cancel')
          }
        })
      }
    }
  },
  watch: {
    subjectId (val) {
      if (val) {
        this.fetch()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ChildAct {
  text-align: left;
  background-color: #fff;
  padding: 0;
}
.childAct-edit {
  background-color: #fff;
  padding-top: 25px;
  padding-left: 24px;
  text-align: left;
  min-height: 704px;
  .known {
    display: inline-block;
    width: 74px;
    text-align: right;
    margin-bottom: 20px;
  }
}
.login-lookup-btn {
  margin-left: 25px;
  width:83px;
  height:32px;
  font-size: 14px;
  border-radius: 2px;
}
.login-lookup-box {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.login-editbtn {
  margin-left: 77px;
  margin-top: 30px;
  width:140px;
  height:30px;
}
/deep/ .ant-select {
  font-size: 12px;
}
.childact-do {
  display: flex;
  a {
    margin-right: 14px;
  }
  .childact-do__freeze{
    color:#E02020;
  }
}
.no-data-box {
  &__img {
    width: 230px;
    margin-top: 20px;
    margin-bottom: 20px;
    img {
      width: 150px;
    }
    text-align: center;
  }
  &__info {
    line-height: 26px;
  }
}
.login-btn {
  min-width:100px;
  height:24px;
  font-size: 14px;
  border-radius:17px;
}
.login-input {
  margin-left: 25px;
  width:270px;
  height:32px;
  color: #989898;
  /deep/ .ant-input {
    font-size: 12px;
  }
}
.refresh {
  width: 30px;
  height: 30px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.refresh:hover {
  transition: 0.4s;
  border: 1px solid #80b3ff;
  color: #80b3ff;
}
.green {
  width: 5px;
  height: 5px;
  background: #52C41A;
  border-radius: 50%;
  margin-right: 5px;
}
.grey {
  width: 5px;
  height: 5px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  margin-right: 5px;
}
</style>
